<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento de Avisos.</span>
                <br/>
                <span class="navigation">Cadastros > Aviso</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-5 mb-2">
                <label for="tipoSelecao">Tipo Seleção:</label>
                <span class="p-fluid">
                  <Dropdown id="tipoSelecao" name="tipoSelecao" v-model="selectedTipoSelecao" :options="tiposSelecao"
                    optionLabel="name" placeholder="Selecione um Tipo" @change="onChangeTipoSelecao()" />
                </span>
              </div>
            </div>
            <div class="row" v-if="selectedTipoSelecao.key === 'S'">
              <div class="col-md-6 mb-2">
                <label for="contr">Contribuinte:</label>
                <span class="p-fluid">
                  <AutoComplete id="contr" ref="contr" v-model="selectedContribuinte" :dropdown="true"
                    :suggestions="filteredContribuintes" @complete="searchContribuinte($event)" field="nome">

                  </AutoComplete>
                </span>
              </div>
              <div class="col-md-6 mb-2">
                <Button
                  v-if="selectedContribuinte != 0"
                  @click="adicionarContribuinte()"
                  style="margin-top: 27px;"
                  label="Adicionar"
                  title="Gravar"
                  type="button"
                  class="p-button-primary mr-2"
                  icon="pi pi-plus"
                  :disabled="loading"
                > 
                </Button>
              </div>
            </div>
            <div v-if="contribuintesList.length != 0" class="row">
              <div class="col-md-10 mb-2">
                <DataTable 
                :value="contribuintesList"
                :paginator="true"
                :rows="5"
                :autoLayout="true"
                style="min-width: 100%; text-align: center"
                >
                  <Column headerStyle="width: 1%">
                    <template #body="rowData">
                      <Button class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" label="Remover" @click="removerContribuinte(rowData)" />
                    </template>
                  </Column>
                  <Column field="nome" header="Nome Contribuinte"></Column>
                  <Column field="documento" header="Documento Contribuinte"></Column>
                </DataTable>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Título:*</label>
                <span class="p-fluid">
                  <InputText
                    type="text"
                    id="nome"
                    v-model="aviso.titulo"
                  />
                </span>
              </div>
              <div class="col-md-2 mb-2">
                <label for="dataVigenciaInicial">Data Vigência Inicial:</label>
                <span class="p-fluid">
                  <InputMask 
                  id="dataVigenciaInicial" 
                  v-model="aviso.dataVigenciaInicial"
                  mask="99/99/9999"/>
                </span>
              </div>
              <div class="col-md-2 mb-2">
                <label for="nome">Data Vigência Final:</label>
                <span class="p-fluid">
                  <InputMask 
                  id="basic" 
                  v-model="aviso.dataVigenciaFinal"
                  mask="99/99/9999"/>
                </span>
              </div>
            </div>
            <br />
            <TabView :activeIndex.sync="indexActive" @tab-change="handleTabChange($event)">
              <TabPanel header="Texto/Anexo">  
                <div class="row">
                  <div class="col-md-8 mb-2">
                    <label for="desc">Mensagem:</label>
                    <span class="p-fluid">
                      <Editor
                        editorStyle="height: 320px"
                        type="text"
                        id="desc"
                        v-model="aviso.mensagem"
                      />
                    </span>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-10 mb-2">
                    <label for="file">Selecionar abaixo um arquivo, caso queira anexar ao registro: </label>
                    <br/>
                    <Button 
                      class="p-button-primary mr-2"
                      icon="pi pi-plus" 
                      @click="openFileInput()" 
                      label="Selecionar Arquivo"
                      type="button"
                      :disabled="desabilitarAnexo || isTipoPopupLogin" />
                    <Button
                      v-if="files.length > 0 && !isTipoPopupLogin"
                      class="p-button-danger mr-2"
                      icon="pi pi-times"
                      @click="closeFileInput()" 
                      label="Cancelar"
                      type="button" />
                      <input style="display: none;" class="button-arquivo" placeholder="Adicionar Arquivo" type="file" id="files" ref="files" :disabled="isTipoPopupLogin" v-on:change="handleFileUpload()" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-5 mb-2">
                    <label style="display: none;" class="label-arquivo">Arquivo Selecionado:</label>
                    <span class="arquivo"></span>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header="Questionário" :disabled="isTipoPopupLogin">
                <Accordion>
                <AccordionTab header="Montar Questionário">
                  <div class="row">
                    <div class="col-md-4 mb-2">
                      <label style="font-weight: bold;" for="assunto">Assunto:</label>
                      <span class="p-fluid">
                        <AutoComplete
                          id="assunto"
                          v-model="selectedAssunto"
                          :dropdown="true"
                          :suggestions="filteredAssunto"
                          @complete="searchAssunto($event)"
                          field="assunto"
                          placeholder="Pesquisar"
                        >
                          <template #item="slotProps">
                            <div  class="p-fluid" style="max-width: 50vw">
                              {{ slotProps.item.assunto }}
                            </div>
                          </template>
                        </AutoComplete>
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 mb-2">
                      <Button @click="showCadAssunto()" label="Novo Assunto" type="button" class="p-button-primary mr-2" icon="pi pi-plus" />
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col-md-6 mb-2">
                      <label style="font-weight: bold;" for="pergunta">Pergunta:</label>
                      <span class="p-fluid">
                        <InputText
                          id="pergunta"
                          v-model="avisoItem.pergunta"
                          placeholder="Pesquisar"
                        />
                      </span>
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-md-10 mb-2">
                      <label style="font-weight: bold;" for="resposta">Resposta:</label>
                      <span class="p-fluid">
                        <Editor
                          editorStyle="height: 220px"
                          type="text"
                          id="resposta"
                          v-model="avisoItem.resposta"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7 mb-2">
                      <Button style="margin-right: 15px;" label="Nova Pergunta" icon="pi pi-plus" class="p-button-primary" @click="clearItem()" :disabled="loading" />
                      <Button label="Gravar Pergunta" icon="pi pi-check" @click="salvarItem()" class="p-button-success" />
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <DataTable :value="itemList" :paginator="true" :rows="4" class="p-datatable-responsive"
                    :autoLayout="true">
                    <Column headerStyle="width: 18em" bodyStyle="text-align: center">
                      <template #body="slotProps">
                        <Button type="button" icon="pi pi-pencil" label="Editar" style="margin-right: .5em" @click="detailItem(slotProps.data.id)"></Button>
                      </template>
                    </Column>
                    <Column bodyStyle="width: 50px;" field="avisoAssunto.assunto" header="Assunto"></Column>
                    <Column field="pergunta" header="Pergunta"></Column>
                    <Column field="resposta" header="Resposta"></Column>
                  </DataTable>
                  </div>
                </AccordionTab>
                </Accordion>
              </TabPanel>
            </TabView>
            <Dialog header="Cadastrar Novo Assunto" :visible.sync="showAssuntoCadastro" :style="{ width: '80vw' }"
              :contentStyle="{ overflow: 'visible' }" :modal="true">
              <div class="row">
                <div class="col-md-4 mb-2">
                  <label for="desc">Novo Assunto:</label>
                  <span class="p-fluid">
                    <InputText
                      type="text"
                      id="desc"
                      v-model="avisoAssunto.assunto"
                    />
                  </span>
                </div>
              </div>
              
              <template #footer>
                <Button label="Gravar" icon="pi pi-check" class="p-button-success" @click="salvarAssunto()" :disabled="loading" />
                <Button label="Fechar" icon="pi pi-times" @click="showAssuntoCadastro = false" class="p-button-danger" />
              </template>
              <hr />
              <div class="card-body">
                <div class="row">
                  <DataTable :value="assuntoList" :paginator="true" :rows="4" class="p-datatable-responsive"
                    :autoLayout="true">
                    <Column headerStyle="width: 16em" bodyStyle="text-align: center">
                      <template #body="slotProps">
                        <Button type="button" icon="pi pi-pencil" label="Editar" style="margin-right: .5em" @click="detailAssunto(slotProps.data.id)"></Button>
                      </template>
                    </Column>
                    <Column field="assunto" header="Assunto"></Column>
                  </DataTable>
                </div>
              </div>
            </Dialog>
            <hr v-if="indexActive === 1" />
            <div class="row" v-if="indexActive === 1">
              <div class="col-md-6 mb-2">
                <label for="assunto">Selecionar Item:*</label>
                <span class="p-fluid">
                  <AutoComplete
                    id="assunto"
                    v-model="selectedItem"
                    :dropdown="true"
                    :suggestions="filteredItem"
                    @complete="searchItem($event)"
                    field="pergunta"
                    placeholder="Pesquisar"
                    :disabled="isTipoPopupLogin"
                    @input="campoInputHandler('questionario')"
                  >
                    <template #item="slotProps">
                      <div  class="p-fluid" style="max-width: 50vw">
                        <b>Assunto: </b>{{ slotProps.item.avisoAssunto ? slotProps.item.avisoAssunto.assunto : '' }}, <b>Pergunta: </b>{{ slotProps.item.pergunta }}
                      </div>
                    </template>
                  </AutoComplete>
                </span>
              </div>
            </div>
            <hr />
            <template>
              <Button
                @click="salvar()"
                label="Gravar"
                title="Gravar"
                type="button"
                class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check"
                :disabled="loading"
              > 
              </Button>
              <router-link to="/avisoConsulta">
                <Button
                  label="Voltar"
                  title="Voltar"
                  type="button"
                  class="p-button-primary mr-2"
                  icon="pi pi-arrow-left"
                  :disabled="loading"
                ></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoginService from "../services/acesso/login.service";
import AvisoService from "../services/nfse/aviso.service";
import AvisoAssuntoService from "../services/nfse/aviso.assunto.service";
import AvisoItemService from "../services/nfse/aviso.item.service";
import UsuarioAcessoService from "../services/nfse/usuario.acesso.service";
import Aviso from "../models/nfse/Aviso";
import AvisoAssunto from "../models/nfse/AvisoAssunto";
import AvisoItem from "../models/nfse/AvisoItem";

export default {
  name: "avisoCadastro",
  data() {
    return {
      currentUser: null,
      loading: false,
      dataVigenciaInicialOriginal: null,
      files: [],
      aviso: new Aviso(),
      avisoAssunto: new AvisoAssunto(),
      avisoItem: new AvisoItem(),
      showAssuntoCadastro: false,
      tipoCadastro: [
        { name:"Texto/Anexo", key: "T" },
        { name: "Questionário", key: "Q" }
      ],
      selectedAssunto: null,
      filteredAssunto: null,
      selectedItem: null,
      filteredItem: null,
      assuntoList: [],
      itemList: [],
      filtro: "",
      desabilitarTexto: true,
      desabilitarAnexo: false,
      desabilitarQuest: false,
      indexActive: 0,
      idAssunto: null,
      idItem: null,
      selectedTipoSelecao: null,
      tiposSelecao: [
        { name: "Exibir após o Login de todos os contribuintes", key: "T" },
        { name: "Exibir após o Login de um contribuinte específico", key: "S" },
        { name: "Exibir na tela de Login", key: "L" },
        { name: "Exibir na tela de Login como popup", key: "P" }
      ],
      selectedContribuinte: [],
      filteredContribuintes: [],
      contribuintesList: []
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.avisoId = this.$route.params.id;
    this.pesquisarItem();
    this.selectedTipoSelecao = this.tiposSelecao[0];

    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const ano = dataAtual.getFullYear();
    this.aviso.dataVigenciaInicial = `${dia}/${mes}/${ano}`;
    this.aviso.tipo = "T";

    if (this.avisoId != null) {
      setTimeout(async () => {
        await AvisoService.findById(this.avisoId).then(
        response =>{
          this.aviso = response.data;
          this.aviso.dataVigenciaInicial = this.formatarData(
            this.aviso.dataVigenciaInicial
          );
          this.dataVigenciaInicialOriginal = this.aviso.dataVigenciaInicial;
          this.aviso.dataVigenciaFinal = this.formatarData(
            this.aviso.dataVigenciaFinal
          );
          //this.aviso.id = null;
          if (this.aviso.tipoEnvio) {
            const foundTipoSelecao = this.tiposSelecao.find(
              t => t.key === this.aviso.tipoEnvio
            );
            if (foundTipoSelecao) {
              this.selectedTipoSelecao = foundTipoSelecao;
            }
          }
          if (this.isTipoPopupLogin) {
            this.onChangeTipoSelecao();
          } else {
            this.selectedAssunto = this.aviso.avisoAssunto;
            this.selectedItem = this.aviso.avisoItem;
            if (this.aviso.tipo === "Q") {
              this.indexActive = 1;
            } else {
              this.indexActive = 0;
            }
            if (this.aviso.nomeArquivo) {
              this.files = [{ name: this.aviso.nomeArquivo }];
              const displayText = this.$el.querySelector('.arquivo');
              const labelArquivo = this.$el.querySelector('.label-arquivo');
              if (displayText && labelArquivo) {
                displayText.textContent = this.aviso.nomeArquivo;
                displayText.style.border = '1px solid black';
                labelArquivo.style.display = 'block';
              }
            }
          }
        },
        error => {
          let errorMessage = "Houve um problema ao buscar o Aviso!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        });
      }, 250);
    }
  },
  mounted() {
    // Setup MutationObserver if needed for dynamic content
    this.setupDOMObserver();
  },

  computed: {
    isTipoPopupLogin() {
      return !!(this.selectedTipoSelecao && this.selectedTipoSelecao.key === "P");
    }
  },
  
  beforeDestroy() {
    // Cleanup
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    formatarData(data) {
      if (!data) {
        return '';
      }
      const partes = data.split('-');
      return `${partes[2]}/${partes[1]}/${partes[0]}`;
    },
    formatarDataParaBanco(data) {
      if (!data) {
        return null;
      }
      const partes = data.split('/');
      return `${partes[2]}-${partes[1]}-${partes[0]}`;
    },
    showCadAssunto(){
      this.showAssuntoCadastro = true;
      this.pesquisar();
    },
    openFileInput(){
      if (this.isTipoPopupLogin) return;
      this.$refs.files.click();
    },
    onChangeTipoSelecao() {
      if (this.isTipoPopupLogin) {
        this.indexActive = 0;
        this.selectedItem = null;
        this.selectedAssunto = null;
        this.closeFileInput();
      }
    },
    closeFileInput(){
      this.files = [];
      this.aviso.nomeArquivo = null;
      this.aviso.tipoArquivo = null;
      this.aviso.file = null;
      this.desabilitarQuest = false;
      console.log(this.files);
      // Reseta o texto do label e do span
      const displayText = document.querySelector('.arquivo');
      if (displayText) {
        displayText.textContent = "";
        displayText.style.border = "none"; // Remove a borda
      }

      // Reseta o texto do label do arquivo
      const labelArquivo = document.querySelector('.label-arquivo');
      if (labelArquivo) {
        labelArquivo.style.display = "none"; // Oculta o label
      }
    },
    adicionarContribuinte() {
      var msg = null;

      if (this.selectedContribuinte.length === 0) {
        msg = "É necessário selecionar um Contribuinte!";
      }else if(!this.selectedContribuinte.idContribuinte){
        msg = "Contribuinte não encontrado!";
      } else if (this.contribuintesList.some(c => c.nome === this.selectedContribuinte.nome)) {
        msg = "O contribuinte já está selecionado!";
      }

      if (!msg) {
        this.contribuintesList.push({
          nome: this.selectedContribuinte.nome,
          documento: this.selectedContribuinte.documento,
          idContribuinte: this.selectedContribuinte.idContribuinte
        });
        console.log(this.selectedContribuinte);
        this.selectedContribuinte = [];
      } else {
        this.$root.$emit("alert:warn", msg);
      }
    },
    removerContribuinte(contribuinte) {
      console.log("Contribuintes na lista incial:", this.contribuintesList.length);
      const index = this.contribuintesList.findIndex(c => c.nome === contribuinte.data.nome && c.documento === contribuinte.data.documento);
      if (index !== -1) {
        this.contribuintesList.splice(index, 1);
      }
      console.log("Contribuintes na lista final:", this.contribuintesList.length);
    },
    handleFileUpload(){
      this.files = this.$refs.files.files;
      this.aviso.file = null;
      if(this.files || this.files.length > 0){
        this.desabilitarQuest = true;
      }

      this.$nextTick(() => {
        const displayText = this.$el.querySelector('.arquivo');
        const dispayLabelArquivo = this.$el.querySelector('.label-arquivo');
        if (displayText && dispayLabelArquivo) {
          displayText.textContent = this.files[0].name;
          displayText.style.border = '1px solid black';
          dispayLabelArquivo.style.display = 'block';
        }
      });
    },
    campoInputHandler(campo) {
      switch (campo) {
        case 'mensagem':
          if (this.aviso.mensagem) {
            this.desabilitarQuest = true;
          } else if(!this.aviso.mensagem) {
            this.desabilitarQuest = false;
          }
          break;
        case 'questionario':
          if (this.selectedItem) {
            this.desabilitarAnexo = true;
            console.log(this.desabilitarTexto);
          } else if(!this.selectedItem){
            this.desabilitarAnexo = false;
          }
          break;
        default:
          break;
      }
    },
    handleTabChange(event) {
      this.indexActive = event.index;
    },
    validarAviso() {
      if (!this.aviso.titulo || !this.aviso.titulo.trim()) {
        this.$root.$emit("alert:warn", "É necessário preencher o campo título!");
        return false;
      }

      if (this.isTipoPopupLogin) {
        const textoMensagem = (this.aviso.mensagem || '').replace(/<[^>]*>/g, '').trim();
        const possuiImagemInline = /<img\b/i.test(this.aviso.mensagem || '');
        if (!textoMensagem && !possuiImagemInline) {
          this.$root.$emit("alert:warn", "Para aviso do tipo popup na tela de Login, é necessário preencher o campo Mensagem!");
          return false;
        }
      }

      if (!this.aviso.dataVigenciaInicial || this.aviso.dataVigenciaInicial.includes('_')) {
        this.$root.$emit("alert:warn", "É necessário preencher a data vigência inicial corretamente!");
        return false;
      }

      const partesIni = this.aviso.dataVigenciaInicial.split('/');
      if (partesIni.length !== 3) {
        this.$root.$emit("alert:warn", "Data vigência inicial inválida!");
        return false;
      }

      const diaIni = parseInt(partesIni[0], 10);
      const mesIni = parseInt(partesIni[1], 10) - 1;
      const anoIni = parseInt(partesIni[2], 10);
      const dataIni = new Date(anoIni, mesIni, diaIni, 0, 0, 0, 0);

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      const dataAlterada = !this.aviso.id || (this.dataVigenciaInicialOriginal && this.aviso.dataVigenciaInicial !== this.dataVigenciaInicialOriginal);

      if (dataAlterada && dataIni < hoje) {
        this.$root.$emit("alert:warn", "A data inicial não pode ser anterior à data atual!");
        return false;
      }

      if (this.aviso.dataVigenciaFinal && !this.aviso.dataVigenciaFinal.includes('_')) {
        const partesFim = this.aviso.dataVigenciaFinal.split('/');
        if (partesFim.length === 3) {
          const diaFim = parseInt(partesFim[0], 10);
          const mesFim = parseInt(partesFim[1], 10) - 1;
          const anoFim = parseInt(partesFim[2], 10);
          const dataFim = new Date(anoFim, mesFim, diaFim, 0, 0, 0, 0);
          if (dataFim < dataIni) {
            this.$root.$emit("alert:warn", "A data final não pode ser anterior à data inicial!");
            return false;
          }
        }
      }

      if (this.indexActive === 1) {
        if (!this.selectedItem || !this.selectedItem.id) {
          this.$root.$emit("alert:warn", "É necessário selecionar um item para o Questionário!");
          return false;
        }
      }

      return true;
    },
    onSubmit() {
      if (this.validarAviso()) {
        this.salvar();
      }
    },
    salvar() {
      if (!this.validarAviso()) {
        return;
      }

      if (this.indexActive === 0 && !this.isTipoPopupLogin && this.files && this.files[0] && (this.files[0] instanceof File || !this.aviso.file)) {
        var fileSize = this.files[0].size / 1024 / 1024; // in MB
        if (fileSize > 20) {
          this.$root.$emit(
            "alert:warn",
            "Este arquivo ultrapassa o limite de 20 MB!"
          );
          return;
        }
        this.processando(true);
        this.getBase64(this.files[0]).then(response => {
          
          let base64 = response.replace("data:", "").replace(/^.+,/, "");
          this.aviso.file = base64;

          this.aviso.nomeArquivo = this.files[0].name;
          this.aviso.tipoArquivo = this.files[0].type;

          this.salvarAviso();
          
        });
      }else{
        this.salvarAviso();
      }
    },
    salvarAviso() {
      this.aviso.statusAtividade = "A";
      if (this.indexActive === 1 && !this.isTipoPopupLogin) {
        this.aviso.tipo = "Q";
        this.aviso.idAssunto = this.selectedItem.idAssunto;
        this.aviso.idItem = this.selectedItem.id;
        this.aviso.avisoAssunto = this.selectedItem.avisoAssunto;
        this.aviso.avisoItem = this.selectedItem;
        this.aviso.mensagem = null;
        this.aviso.file = null;
        this.aviso.nomeArquivo = null;
        this.aviso.tipoArquivo = null;
      } else {
        this.aviso.tipo = "T";
        this.aviso.idAssunto = null;
        this.aviso.idItem = null;
        this.aviso.avisoAssunto = null;
        this.aviso.avisoItem = null;
        if (this.isTipoPopupLogin) {
          this.aviso.file = null;
          this.aviso.nomeArquivo = null;
          this.aviso.tipoArquivo = null;
        }
      }
      this.aviso.tipoEnvio = this.selectedTipoSelecao ? this.selectedTipoSelecao.key : 'T';
      if(this.contribuintesList && this.contribuintesList.length > 0){
        this.aviso.contribuintes = this.contribuintesList.map(contribuinte => ({
          idContribuinte: contribuinte.idContribuinte
        }));
      }
      this.aviso.idCliente = this.currentUser.usuario.idCliente;
      this.aviso.dataVigenciaInicial = this.formatarDataParaBanco(
        this.aviso.dataVigenciaInicial
      );
      this.aviso.dataVigenciaFinal = this.formatarDataParaBanco(
        this.aviso.dataVigenciaFinal
      );
      AvisoService.saveAviso(this.aviso).then(
        data => {
          this.processando(false);
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Aviso salvo com sucesso",
            life: 3000
          });
          this.clearAviso();
          this.$router.push("avisoConsulta");
        },
        error => {
          this.processando(false);
          let errorMessage = "Houve um problema ao salvar o Aviso!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
            life: 3000
          });
        }
      );
    },
    salvarAssunto(){
      this.avisoAssunto.idCliente = this.currentUser.usuario.idCliente;
      var msg = null;
      if(this.avisoAssunto.assunto == ""){
        msg = "É necessário preencher o campo Assunto!";
      }
      if(!msg){
        AvisoAssuntoService.saveAssunto(this.avisoAssunto).then(
          data => {
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Assunto salvo com sucesso",
              life: 2000
            });
            this.pesquisar();
            this.clearAssunto();
            // this.$router.push("avisoConsulta");
          },
          error => {
            let errorMessage = "Houve um problema ao salvar o Assunto!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage,
              life: 2000
            });
          }
        );
      }else{
        this.$root.$emit("alert:warn", msg);
      }
    },
    salvarItem(){
      let msg = null;
      this.processando(true);
      if(!this.selectedAssunto || !this.selectedAssunto.id){
        msg = "É necessário selecionar um Assunto!";
        this.processando(false);
      }else if(this.avisoItem.pergunta == null || this.avisoItem.pergunta == ""){
        msg = "É necessário preencher o campo Pergunta!";
        this.processando(false);
      }else if(this.avisoItem.resposta == null || this.avisoItem.resposta == ""){
        msg = "É necessário preencher o campo Resposta!";
        this.processando(false);
      }

      if(!msg){
        this.avisoItem.idCliente = this.currentUser.usuario.idCliente;
        this.avisoItem.idAssunto = this.selectedAssunto.id;
        this.avisoItem.avisoAssunto = this.selectedAssunto;

        AvisoItemService.saveItem(this.avisoItem).then(
          data =>{
            console.log(data);
            this.$toast.add({
              severity: "success",
              summary: "Item Salvo Com Sucesso!",
              life: 3000
            });
            this.clearItem();
            this.pesquisarItem();
          },
          error =>{
            let errorMessage = "Houve um erro ao salvar o Item!";
            if(error.response){
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage,
              life: 3000
            });
          }
        )
        this.processando(false);
      }else{
        this.$root.$emit("alert:warn", msg);
        this.processando(false);
      }
    },
    detailAssunto(assuntoId){
      this.idAssunto = assuntoId;
      if (this.idAssunto != null) {
        setTimeout(async () => {
          await AvisoAssuntoService.findAssuntoById(this.idAssunto).then(
          response =>{
            this.avisoAssunto = response.data;
            console.log(this.avisoAssunto);
          },
          error => {
            let errorMessage = "Houve um problema ao buscar o Assunto!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          });
        }, 250);
      }
    },
    detailItem(itemId){
      this.idItem = itemId;
      console.log(this.idItem);
      if (this.idItem != null) {
        setTimeout(async () => {
          await AvisoItemService.findItemById(this.idItem).then(
          response =>{
            this.avisoItem = response.data;
            this.selectedAssunto = this.avisoItem.avisoAssunto;
            console.log(this.avisoItem);
          },
          error => {
            let errorMessage = "Houve um problema ao buscar o Item!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          });
        }, 250);
      }
    },
    pesquisar() {
			this.search = true;
			AvisoAssuntoService.findAssuntoByFiltro(
				this.currentUser.usuario.idCliente,
				this.filtro
			).then(
				assuntos => {
					this.assuntoList = assuntos.data;
				},
				error => {
					let errorMessage = "Houve um problema ao listar Assuntos!";
					if (error.response) {
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage,
            life: 3000
					});
				}
			);
			this.search = false;
		},
    pesquisarItem(){
      this.processando(true);
			AvisoItemService.findAllItensByFiltro(
				this.currentUser.usuario.idCliente,
				this.filtro
			).then(
				itens => {
					this.itemList = itens.data;
				},
				error => {
					let errorMessage = "Houve um problema ao listar Itens!";
					if (error.response) {
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage,
            life: 3000
					});
				}
			);
			this.processando(false);
    },
    searchContribuinte(event) {
      setTimeout(async () => {
        this.filteredContribuintes =
          await UsuarioAcessoService.findAllContrs(
            this.currentUser.usuario.idCliente,
            this.currentUser.usuario.idUsuario,
            event.query

          )

      }, 500);
    },
    searchAssunto(event){
      setTimeout(async () => {
        this.filteredAssunto = await AvisoAssuntoService.findAssunto(
          this.currentUser.usuario.idCliente,
          event.query
        );
      }, 550)
    },
    searchItem(event){
      setTimeout(async () => {
        this.filteredItem = await AvisoItemService.findItem(
          this.currentUser.usuario.idCliente,
          event.query
        );
      }, 550)
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },
    clearAviso(){
      this.aviso.mensagem = '';
      this.files = "";
    },
    clearAssunto(){
      this.avisoAssunto.assunto = "";
    },
    clearItem(){
      this.avisoItem.pergunta = "";
      this.avisoItem.resposta = "";
      this.selectedAssunto = null;
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    setupDOMObserver() {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            // Handle any dynamic content changes
          }
        });
      });

      // Observe the target node
      const target = this.$el; // or specific element
      this.observer.observe(target, {
        childList: true,
        subtree: true
      });
    },
  }
};
</script>

<style src="../assets/css/avisoCadastro.css"></style>